import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MyInput, MySelect } from '../../../../../../../Base/Form';
import GeneratorLabel from '../../../../../../PreparedMessages/TemplateMessages/components/GeneratorLabel/GeneratorLabel';
import { TEMPLATE_HEADER_TYPE } from '../../../../../../../../constants';
import { useStore } from '../../../../../../../../store/rootStore';
import { observer } from 'mobx-react';
import s from '../RichParams.module.scss';
const HeaderSection = ({ blockField }) => {
    const { templateMessagesStore: { richTemplateHeaderType, richTemplateHeader, handleSetHeader, handleRichTemplateHeaderType, currentTemplate, }, } = useStore();
    const { t } = useTranslation();
    const isLegacyTextHeader = currentTemplate && richTemplateHeaderType === TEMPLATE_HEADER_TYPE.TEXT;
    const headerOptions = useMemo(() => {
        const options = [
            {
                label: React.createElement(Trans, { i18nKey: "none" }),
                value: '',
            },
            {
                label: React.createElement(Trans, { i18nKey: "image" }),
                value: TEMPLATE_HEADER_TYPE.IMAGE,
            },
            {
                label: React.createElement(Trans, { i18nKey: "video" }),
                value: TEMPLATE_HEADER_TYPE.VIDEO,
            },
            {
                label: React.createElement(Trans, { i18nKey: "file" }),
                value: TEMPLATE_HEADER_TYPE.DOCUMENT,
            },
        ];
        if (isLegacyTextHeader) {
            options.splice(1, 0, {
                label: React.createElement(React.Fragment, null,
                    React.createElement(Trans, { i18nKey: "text" }),
                    " ",
                    React.createElement(Trans, { i18nKey: "legacy" })),
                value: TEMPLATE_HEADER_TYPE.TEXT,
            });
        }
        return options;
    }, [isLegacyTextHeader, t]);
    return (React.createElement("div", { className: s.templateAddHeader },
        React.createElement(GeneratorLabel, { textKey: "header" }),
        React.createElement(MySelect, { disabled: blockField(), defaultValue: null, onChange: (value) => {
                handleSetHeader('');
                handleRichTemplateHeaderType(value);
            }, value: richTemplateHeaderType !== null && richTemplateHeaderType !== void 0 ? richTemplateHeaderType : '', size: "large", options: headerOptions }),
        richTemplateHeaderType === TEMPLATE_HEADER_TYPE.TEXT && (React.createElement(MyInput, { value: richTemplateHeader, onChangeHandler: handleSetHeader, placeholder: t('headerText'), disabled: blockField(), size: "large" }))));
};
export default observer(HeaderSection);
